import cn from 'classnames'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'

import { BackButton, Icon, MainButton, View } from '@ds'
import { MainLayout, useUserAchievements } from '@shared'
import {
  useGetCardsQuest,
  useGetCardsSkins,
  useStatisticActions,
  useUser,
  useUserBankStars,
} from '@store'

import styles from './Profile.module.scss'
import { CardCollection, ProfileEdit } from './components'
import { Achievements } from './components/Achievements'
import { Avatar } from './components/Avatar'
import { CollectedItems } from './components/CollectedItems'
import { CollectedStars } from './components/CollectedStars'
import { CollectedStarsStat } from './components/CollectedStarsStat'
import { InviteLink } from './components/InviteLink'
import { ItemsRating } from './components/ItemsRating'
import { Shop } from './components/Shop'
import { ProfilePencilIcon } from './icons/ProfilePencilIcon'

export const Profile = () => {
  const [isEditMode, setIsEditMode] = useState(false)
  const navigate = useNavigate()
  const { achievements } = useUserAchievements()
  const questItems = useGetCardsQuest();
  const skins = useGetCardsSkins();
  const { profile } = useUser()
  const { fetchProfile } = useUser().actions
  const { fetchCollectedStarsStatistic } = useStatisticActions()
  const totalCollectedStars = useUserBankStars()

  useEffect(() => {
    fetchProfile()
  }, [])
  useEffect(() => {
    fetchCollectedStarsStatistic()
  }, [fetchCollectedStarsStatistic])

  const ratingItems = useMemo(() => {
    return skins.slice(0, 10)
  }, [skins])

  const handleEditButtonClick = () => {
    setIsEditMode((prev) => !prev)
  }

  const renderContent = () => {
    if (isEditMode) {
      return <ProfileEdit />
    }

    return (
      <>
        <Avatar />
        <Icon className={styles.settingsIcon} name="gear" size="L" onClick={() => navigate('/settings')} />
        {/* <Progress /> */}
        <InviteLink className={styles.inviteLink} />
        {profile && (
          <ItemsRating items={ratingItems} rating={profile.rating} />
        )}
        <Achievements achievements={achievements} />
        <CollectedItems items={questItems} />
        <CollectedStars stars={totalCollectedStars || 0} />
        <CollectedStarsStat />
        <CardCollection />
        <Shop />
      </>
    )
  }

  return (
    <MainLayout showInventory={false} isNavbarFadeble>
      {(scrollRef) => (
        <>
          <BackButton onClick={() => navigate('/')} />
          <MainButton hidden />

          <View fadeIn className={styles.view} ref={scrollRef}>
            <button
              onClick={handleEditButtonClick}
              className={styles.editButton}
            >
              <ProfilePencilIcon
                className={cn(styles.editButtonIcon, {
                  [styles['editButtonIcon__open']]: isEditMode,
                })}
              />
            </button>
            <div
              className={cn(styles.container, {
                [styles.container__edit]: isEditMode,
              })}
            >
              {renderContent()}
            </div>
          </View>
        </>
      )}
    </MainLayout>
  )
}
